import { render } from "./BlogDetailsRightSidebar.vue?vue&type=template&id=2174f648"
import script from "./BlogDetailsRightSidebar.vue?vue&type=script&lang=js"
export * from "./BlogDetailsRightSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__